import React from 'react';
import RegistrationLayout from '../../Components/layout/RegistrationLayout';
import RegistrationFormBox from '../../Components/layout/RegistrationFormBox';
import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1';
import { useLocation, useNavigate } from 'react-router-dom';
import RegistrationStep1 from './RegistrationStep1';
import CustomVerticalStepper from '../../Components/CustomVerticalStepper';
import pinSteps from './pinSteps';
import RegistrationStep2 from './RegistrationStep2';
import RegistrationStep4 from './RegistrationStep4';
import RegistrationStep5 from './RegistrationStep5';
import MarkEmailReadIcon from '@mui/icons-material/MarkEmailRead';

const Registration = () => {

  const navigate = useNavigate()
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const step = queryParams.get('step') || '1';

  const handleNextStep = () => {
    const nextStep = parseInt(step) + 1;
    navigate(`/registration?step=${nextStep}`);
  };

  return (
    <RegistrationLayout>
      {/*<GlobalDialog open={open} onClose={()=>{setOpen(false)}} title={"ksjdbgfkjsdbagkabsg"} content={"lkanjgélroaehgleangleranhglnghleannghnnhnhng"} variant={'error'}/>*/}
      <RegistrationFormBox text={step === '5'? "Nézd meg az email fiókodat" : "Regisztráció"} icon={step === '5' ? <MarkEmailReadIcon sx={{fontSize: '30px'}}/> : <PersonAddAlt1Icon sx={{fontSize: '30px'}}/>}>
        {step === '1' &&
          <RegistrationStep1  handleNextStep={handleNextStep} />
        }
        {step === '2' &&
          <RegistrationStep2  handleNextStep={handleNextStep} />
        }
        {step === '3' &&
          <CustomVerticalStepper steps={pinSteps}  handleNextStep={handleNextStep}/>
        }
        {step === '4' &&
         <RegistrationStep4 handleNextStep={handleNextStep}  />
        }
        {step === '5' &&
          <RegistrationStep5  />
        }
      </RegistrationFormBox>
    </RegistrationLayout>
  );
}

export default Registration;